import { createContext, useContext } from 'react';

import {
  type NestedFormFieldProps,
  type InputFieldProps,
  type ReadOnlyFieldProps,
  type SubmitButtonFieldProps,
} from '../types';
import { type FormValues, type PossibleValues } from '../ui/form/types';

type FieldPropsV2 =
  | InputFieldProps<PossibleValues>
  | ReadOnlyFieldProps
  | NestedFormFieldProps<FormValues>
  | SubmitButtonFieldProps;

export type FieldProps = { v2: FieldPropsV2 };

export const FieldPropsContext = createContext<FieldProps | undefined>(
  undefined,
);

export function useFieldProps<
  T extends FieldProps | { v2: FieldPropsV2 },
>(): T {
  const context = useContext(FieldPropsContext);

  if (typeof context === 'undefined') {
    throw new Error('useFieldProps must be used within a FieldPropsProvider');
  }

  return context as T;
}

export function useFieldPropsV2<
  T extends FieldPropsV2 = InputFieldProps<PossibleValues>,
>(): T {
  return useFieldProps<{ v2: T }>().v2;
}
